import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  CustomSelectComponent,
  buildWhereForDates,
  FormCol2,
  FormCol4,
  FormRow,
  FormCol3,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { useRootStore } from 'store';
import {
  FieldSelectContributionPeriod,
  FieldSelectContributionPeriodGroups,
  FieldSelectContributionSeries,
  FieldSelectContributionState,
} from '../../components';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ '$contributor.name$': likeObj }],
      };
    }
    if (values.year !== undefined && values.year !== null && values.year !== '') {
      where = { ...where, year: values.year };
    }

    if (
      values.contributionPeriodGroupId !== undefined &&
      values.contributionPeriodGroupId !== null &&
      values.contributionPeriodGroupId !== ''
    ) {
      where = {
        ...where,
        '$contributionperiod.contributionPeriodGroupId$': values.contributionPeriodGroupId,
      };
    }

    if (values.periodId !== undefined && values.periodId !== null && values.periodId !== '') {
      where = { ...where, periodId: values.periodId };
    }
    if (values.seriesId !== undefined && values.seriesId !== null && values.seriesId !== '') {
      where = { ...where, seriesId: values.seriesId };
    }
    if (values.contributorId) where = { ...where, contributorId: values.contributorId };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  console.log('$$$$ contribitions-filters-initialvalues', initialValues);
  //
  const { t } = useTranslation();
  const { appStore } = useRootStore();
  //
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    year: initialValues?.year ?? null,
    periodId: initialValues?.periodId ?? null,
    seriesId: initialValues?.seriesId ?? undefined,
    contributionPeriodGroupId: initialValues?.contributionPeriodGroupId ?? null,
    contributorId: initialValues?.contributorId ?? undefined,
  };

  const yearOptions = () => {
    const firstYear = 2013;
    const newDate = new Date();
    const currentYear = newDate.getFullYear() + 2024 - newDate.getFullYear();
    const years = currentYear - firstYear;
    const options = [{ value: currentYear.toString(), label: currentYear.toString() }];

    let nextYear;
    for (let i = years - 1; i > 0; i--) {
      nextYear = firstYear + i;
      options.push({ value: nextYear.toString(), label: nextYear.toString() });
    }
    if (firstYear !== currentYear) {
      options.push({ value: firstYear.toString(), label: firstYear.toString() });
    }
    //console.log('number of years difference is ', years);
    return options;
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        {appStore.isPlatformOwner && !isGridInForm && (
          <FieldInput
            as={FormCol}
            name="searchText"
            label={t('Αναζήτηση (Υπόχρεος)')}
            type="search"
          />
        )}
        <Field
          name={'year'}
          title={t('Έτος')}
          component={CustomSelectComponent}
          options={yearOptions()}
        />
        <FieldSelectContributionPeriod as={FormCol}></FieldSelectContributionPeriod>
        <FieldSelectContributionSeries as={FormCol} />
        {appStore.isPlatformOwner && (
          <FieldSelectContributionPeriodGroups
            as={FormCol}
            name="contributionPeriodGroupId"
          ></FieldSelectContributionPeriodGroups>
        )}
      </Row>
    </FormFilterCard>
  );
};

